import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SearchPipe } from '../pipes/search.pipe';
import { PluginsModule } from '../plugins/plugins.module';
import { AdminAccessDirective } from '../directives/admin-access.directive';
import { SuperAdminAccessDirective } from '../directives/super-admin-access.directive';



@NgModule({
  declarations: [
    SearchPipe,
    AdminAccessDirective,
    SuperAdminAccessDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PluginsModule
  ],
  exports: [
    SearchPipe,
    ReactiveFormsModule,
    FormsModule,
    PluginsModule,
    AdminAccessDirective,
    SuperAdminAccessDirective
  ]
})
export class SharedModule { }
